export default __webpack_public_path__ + "static/media/983.717c8147.jpg";